import React, { Component } from "react";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import { CloseButton } from "../components/CloseButton";

import searchFindFairScene from "../../assets/images/search-find/scenes/fair-scene.svg";
import searchFindFairSceneThumbnail from "../../assets/images/search-find/scenes/fair-scene-thumb.jpg";
import searchForestScene from "../../assets/images/search-find/scenes/forest-scene.svg";
import searchForestSceneThumbnail from "../../assets/images/search-find/scenes/forest-scene-thumbnail.jpg";

import searchHouseScene from "../../assets/images/search-find/scenes/house-scene.svg";
import searchHouseSceneThumbnail from "../../assets/images/search-find/scenes/house-scene-thumbnail.jpg";

import searchSeaScene from "../../assets/images/search-find/scenes/sea-scene.svg";
import searchSeaSceneThumbnail from "../../assets/images/search-find/scenes/sea-scene-thumbnail.jpg";

import searchSkyScene from "../../assets/images/search-find/scenes/sky-scene.svg";
import searchSkySceneThumbnail from "../../assets/images/search-find/scenes/sky-scene-thumbnail.jpg";

import searchSportsScene from "../../assets/images/search-find/scenes/sports-scene.svg";
import searchSportsSceneThumbnail from "../../assets/images/search-find/scenes/sports-scene-thumbnail.jpg";

import searchTownScene from "../../assets/images/search-find/scenes/town-scene.svg";
import searchTownSceneThumbnail from "../../assets/images/search-find/scenes/town-scene-thumbnail.jpg";

import characterMrAdventure from "../../assets/images/characters/character-mr-adventure.png";
import characterMissExplorer from "../../assets/images/characters/character-little-miss-explorer.png";
import searchFindWellDoneText from "../../assets/images/search-find-well-done.png";
import { SearchFind } from "../../modules/SearchFind";
import { ConfettiAnimation } from "../components/animations/ConfettiAnimation";
import { BeeAnimation } from "../components/animations/BeeAnimation";
import { BirdAnimation } from "../components/animations/BirdAnimation";

export interface SearchFindScreenProps
{
}

interface SearchFindScreenState 
{
    screen: Screen;
    showGetReady: boolean;
    showCharactersFound: boolean;
    showAnimation: boolean;
    characters: Array<JSX.Element>;
}

export interface Scene
{
    id: number;
    src: string;
    zoomWidth: number;
    zoomHeight: number;
    alt: string;
    thumbnail: string;
}


enum Screen 
{
    SceneSelect,
    Scene,
    SceneComplete
}

enum Character 
{
    MissExplorer = "missExplorer",
    MrAdventure = "mrAdventure"
}

interface CharacterHolder 
{
    id: Character;
    src: string;
    found: boolean;
    alt: string;
}



export class SearchFindScreen extends Component<SearchFindScreenProps, SearchFindScreenState>
{
    private scenes: Array<Scene> = [];
    private searchFind: SearchFind;
    private sceneRef: React.RefObject<HTMLDivElement>;

    private characters: Array<CharacterHolder> = [];

    constructor(props: SearchFindScreenProps)
    {
        super(props);

        this.state = {
            screen: Screen.SceneSelect,
            characters: null,
            showGetReady: false,
            showCharactersFound: false,
            showAnimation: false
        };

        this.scenes = [
            {
                id: 1,
                src: searchFindFairScene,
                zoomWidth: 1139,
                zoomHeight: 930.5,
                alt: "Fairground",
                thumbnail: searchFindFairSceneThumbnail
            },
            {
                id: 2,
                src: searchForestScene,
                zoomWidth: 1136,
                zoomHeight: 950,
                alt: "Forest",
                thumbnail: searchForestSceneThumbnail
            },
            {
                id: 3,
                src: searchHouseScene,
                zoomWidth: 1117.5,
                zoomHeight: 948.5,
                alt: "House",
                thumbnail: searchHouseSceneThumbnail
            },
            {
                id: 4,
                src: searchSeaScene,
                zoomWidth: 1127,
                zoomHeight: 943,
                alt: "Sea",
                thumbnail: searchSeaSceneThumbnail
            },
            {
                id: 5,
                src: searchSkyScene,
                zoomWidth: 1142,
                zoomHeight: 950,
                alt: "Sky",
                thumbnail: searchSkySceneThumbnail
            },
            {
                id: 6,
                src: searchSportsScene,
                zoomWidth: 1146.5,
                zoomHeight: 950,
                alt: "Sports",
                thumbnail: searchSportsSceneThumbnail
            },
            {
                id: 7,
                src: searchTownScene,
                zoomWidth: 1129.5,
                zoomHeight: 950,
                alt: "Town",
                thumbnail: searchTownSceneThumbnail
            }
        ];

        this.sceneRef = React.createRef();
    }

    public componentDidMount(): void
    {
        this.restartScene();
    }

    private restartScene(): void
    {
        document.body.classList.remove("scene-active");
        document.body.classList.remove("scene-complete");

        this.characters = [
            {
                id: Character.MrAdventure,
                src: characterMrAdventure,
                found: false,
                alt: "Mr Adventure"
            },
            {
                id: Character.MissExplorer,
                src: characterMissExplorer,
                found: false,
                alt: "Miss Explorer"
            },
        ];
    }

    private onCloseClicked(): void
    {
        document.body.classList.remove("scene-active");

        if (this.state.screen === Screen.Scene)
        {
            this.restartScene();

            this.setState({
                screen: Screen.SceneSelect,
            });
        }
        else 
        {
            App.I.changeScreen(AppScreen.Landing);
        }
    }

    private onSceneChanged(scene: Scene): void
    {
        document.body.classList.add("scene-active");

        this.setState({
            screen: Screen.Scene,
            showGetReady: true,
            characters: this.buildCharacters()
        },
            () => this.onInitScene(scene)
        );
    }

    private onInitScene(scene: Scene): void
    {
        this.searchFind = new SearchFind(
            this.sceneRef.current,
            scene.src,
            this.onCharacterFound.bind(this),
            [
                Character.MissExplorer,
                Character.MrAdventure
            ],
            scene.zoomWidth,
            scene.zoomHeight
        );
    }

    private onCharacterFound(character: Character): void
    {
        for (let i = 0; i < this.characters.length; i++)
        {
            if (this.characters[i].id === character)
            {
                this.characters[i].found = true;
                break;
            }
        }

        this.setState({
            characters: this.buildCharacters()
        });

        this.checkHasCompleted();
    }

    private checkHasCompleted(): void
    {
        let foundAllCharacters: Array<CharacterHolder> = this.characters.filter(c => c.found === true);
        if (foundAllCharacters.length === this.characters.length)
        {
            this.setState({
                showAnimation: true
            });
        }
    }

    private complete(): void 
    {
        document.body.classList.remove("scene-active");
        document.body.classList.add("scene-complete");
        this.setState({
            screen: Screen.SceneComplete
        });
    }

    private buildCharacters(): Array<JSX.Element>
    {
        let characters: Array<JSX.Element> = [];

        for (let i = 0; i < this.characters.length; i++)
        {
            let characterHolder: CharacterHolder = this.characters[i];

            characters.push(
                <div className={"character" + (characterHolder.found === true ? " active" : "")} key={characterHolder.id}>
                    <img src={characterHolder.src} alt={characterHolder.alt} />
                </div>
            );
        }

        return characters;
    }

    private onViewScenesClicked(): void
    {
        this.restartScene();
        document.body.classList.remove("scene-active");

        this.setState({
            screen: Screen.SceneSelect,
            showGetReady: false,
            showCharactersFound: false
        });
    }

    private onStartSearchingClicked(): void
    {
        this.setState({
            showGetReady: false,
            showCharactersFound: true
        });
    }

    private onPlayAgainClicked(): void
    {
        this.restartScene();
        this.setState({
            screen: Screen.SceneSelect,
            characters: null,
            showCharactersFound: false,
            showGetReady: false
        });
    }

    private onAnimationComplete(): void 
    {
        this.setState({
            showAnimation: false
        });

        this.complete();
    }

    public render(): JSX.Element
    {
        return (
            <>
                <CloseButton onClicked={this.onCloseClicked.bind(this)} />

                <div className="screen-search-find">

                    {
                        (() => 
                        {
                            switch (this.state.screen)
                            {

                                case Screen.SceneComplete:
                                    return (
                                        <>
                                            <div className="bird-animation">
                                                {/* <BirdAnimation /> */}
                                            </div>
                                            <div className="container">
                                                <div className="search-find-container mt-2">
                                                    <div className="heading-container">

                                                        <img src={searchFindWellDoneText} alt="Well done! You completed the quiz!" />
                                                    </div>

                                                    <div className="mt-3 mb-5 ms-auto me-auto">
                                                        <button className="btn btn-primary" onClick={this.onPlayAgainClicked.bind(this)}>Play again</button>
                                                    </div>
                                                </div>

                                                <div className="d-flex ms-auto me-auto more">
                                                    <button className="btn btn-link" onClick={() => App.I.changeScreen(AppScreen.GamesActivities)}>
                                                        More games
                                                        <i className="bi bi-chevron-right ps-1"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    );

                                case Screen.SceneSelect:
                                    return (
                                        <div className="container">
                                            <div className="search-find-container">
                                                <h1 className="lead-title text-uppercase text-center">
                                                    Search and Find
                                                </h1>

                                                <h2 className="sub-title text-center">
                                                    Mr. Adventure and Little Miss Explorer are hiding!
                                                    Select a scene and start searching!
                                                </h2>

                                                {this.scenes.map(s =>
                                                    <div className="mt-2 mb-2" onClick={this.onSceneChanged.bind(this, s)} key={s.id}>
                                                        <img src={s.thumbnail} alt={s.alt} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );

                                case Screen.Scene:
                                    return (
                                        <>
                                            {this.state.showGetReady ?
                                                <>
                                                    <div className="get-ready-notification">
                                                        <h3 className="text-uppercase mb-4">Get ready!</h3>
                                                        <p className="mb-4 text-body">
                                                            Drag the scene around and look for
                                                            Mr. Adventure and Little Miss Explorer.
                                                            Tap them if you find them!
                                                        </p>
                                                        <button className="btn btn-primary" onClick={this.onStartSearchingClicked.bind(this)}>Start Searching</button>
                                                    </div>
                                                </>
                                                : null
                                            }
                                            {this.state.showCharactersFound ?
                                                <>
                                                    <div className="characters">
                                                        {this.state.characters}
                                                    </div>

                                                    <div className="choose-another-scene" onClick={this.onViewScenesClicked.bind(this)}>
                                                        Choose another scene
                                                        <i className="bi bi-chevron-right ps-1"></i>
                                                    </div>
                                                </>
                                                : null
                                            }
                                            {this.state.showAnimation ?
                                                <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, top: 0, zIndex: 2 }}>
                                                    <ConfettiAnimation onComplete={this.onAnimationComplete.bind(this)} />
                                                </div>
                                                : null
                                            }
                                            <div id="scene" ref={this.sceneRef}></div>
                                        </>
                                    );
                            }
                        })()
                    }
                </div>
            </>
        );
    }

    public componentWillUnmount(): void
    {
        document.body.classList.remove("scene-active");
        document.body.classList.remove("scene-complete");
    }
}